const isBazaarvoiceJsonLdFragment = (node) => {
    if (!node || typeof node !== 'object' || Array.isArray(node)) {
        return false
    }
    const hasBvContent = Boolean(node.aggregateRating || node.review)
    const types = [].concat(node['@type'])
    const hasProductType = types.includes('Product') || types.includes('ProductGroup')
    return hasBvContent && !hasProductType
}

export const removeBazaarvoiceJsonLdFragments = () => {
    if (typeof document === 'undefined') {
        return
    }

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
        const id = (script.id || '').toLowerCase()
        if (id.includes('bv-jsonld') || id.includes('bv-geo')) {
            script.remove()
            return
        }

        try {
            const parsed = JSON.parse(script.textContent || '')
            const nodes = Array.isArray(parsed) ? parsed : [parsed]
            if (nodes.some(isBazaarvoiceJsonLdFragment)) {
                script.remove()
            }
        } catch {
            return
        }
    })
}

export const observeBazaarvoiceJsonLdFragments = () => {
    removeBazaarvoiceJsonLdFragments()

    if (typeof MutationObserver === 'undefined' || typeof document === 'undefined') {
        return () => {}
    }

    let timeoutId
    const observer = new MutationObserver(() => {
        window.clearTimeout(timeoutId)
        timeoutId = window.setTimeout(removeBazaarvoiceJsonLdFragments, 50)
    })
    observer.observe(document.documentElement, {childList: true, subtree: true})
    return () => {
        window.clearTimeout(timeoutId)
        observer.disconnect()
    }
}
